import type { ClusterStatus } from '@/features/mdm/types';

const STYLES: Record<ClusterStatus, string> = {
  open: 'bg-amber-50 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300',
  approved: 'bg-green-50 text-green-700 dark:bg-green-500/15 dark:text-green-300',
  rejected: 'bg-slate-100 text-slate-500 dark:bg-white/10 dark:text-ink-300',
};

const LABELS: Record<ClusterStatus, string> = {
  open: 'Needs review',
  approved: 'Confirmed',
  rejected: 'Not a match',
};

export function ClusterStatusPill({ status }: { status: ClusterStatus }): JSX.Element {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${STYLES[status]}`}
    >
      {LABELS[status]}
    </span>
  );
}
